var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { QueryList } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
var IncomingContactComponent = /** @class */ (function () {
    function IncomingContactComponent(util, router, activatedRoute, apiService) {
        this.util = util;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.apiService = apiService;
        this.isCheckedAll = false;
        this.confirmMergeList = {
            firstname: "",
            lastname: "",
            birthdate: "",
            dpa_idcard: "",
            emailaddress1: "",
            telephone1: "",
            dob: ""
        };
        this.firstnameSearch = "";
        this.lastnameSearch = "";
        this.telephoneSearch = "";
        this.idcardSearch = "";
        this.accountNoSearch = "";
        this.contact1 = {
            firstname: "",
            lastname: "",
            birthdate: "",
            dpa_idcard: "",
            emailaddress1: "",
            telephone1: "",
            dob: null
        };
        this.contact2 = {
            firstname: "",
            lastname: "",
            birthdate: "",
            dpa_idcard: "",
            emailaddress1: "",
            telephone1: "",
            dob: null
        };
        this.chkMain = 1;
        this.chkName = 1;
        this.chkLastname = 1;
        this.chkDob = 1;
        this.chkIdNo = 1;
        this.chkEmail = 1;
        this.chkTel = 1;
        this.dtCon = null;
        this.role = {};
        this.isCrisis = true;
    }
    IncomingContactComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var para, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        this.util.InitValidation();
                        this.activatedRoute.queryParams.subscribe(function (params) {
                            _this.telephoneNo = params['phoneNo'];
                            _this.idCard = params['idCard'];
                        });
                        para = "telephoneno=" + this.telephoneNo;
                        this.telephoneSearch = this.telephoneNo;
                        if (this.idCard != null && this.idCard.trim().length > 0) {
                            para += "&idcard=" + this.idCard;
                            this.idcardSearch = this.idCard;
                        }
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("crmservice", "contact", para)];
                    case 1:
                        _a.contactList = _b.sent();
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"));
                        this.role = JSON.parse(this.cookieData.role);
                        this.isCrisis = this.cookieData.isCrisis;
                        this.util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    IncomingContactComponent.prototype.clearActionActive = function () {
        $(".action-menu").each(function () {
            $(this).removeClass("active");
        });
    };
    IncomingContactComponent.prototype.CloseModal = function (modalId) {
        $("#" + modalId).modal("hide");
        this.clearActionActive();
    };
    IncomingContactComponent.prototype.newContact = function (event) {
        this.cookieData.incomingTelephoneNo = this.telephoneNo;
        this.cookieData.incomingIdCard = this.idCard;
        localStorage.setItem("dpa_cc", JSON.stringify(this.cookieData));
        var url = this.util.baseUrl() + "/newContact";
        window.open(url, '_blank');
    };
    IncomingContactComponent.prototype.merge = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var c;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.getSelectedContact();
                        if (!(this.selectList.length != 2)) return [3 /*break*/, 1];
                        this.util.WarningDialog("กรุณาเลือก 2 รายการ");
                        return [3 /*break*/, 5];
                    case 1:
                        if (!(this.selectList[0].fullname != this.selectList[1].fullname)) return [3 /*break*/, 2];
                        this.util.WarningDialog("กรุณาเลือก 2 รายการที่มีชื่อ นามสกุล ตรงกัน");
                        return [3 /*break*/, 5];
                    case 2:
                        this.util.ShowWaiting(true);
                        c = void 0;
                        return [4 /*yield*/, this.apiService.get("crmservice", "contact", "contactid=" + this.selectList[0].contactId)];
                    case 3:
                        c = _a.sent();
                        this.contact1 = c[0];
                        return [4 /*yield*/, this.apiService.get("crmservice", "contact", "contactid=" + this.selectList[1].contactId)];
                    case 4:
                        c = _a.sent();
                        this.contact2 = c[0];
                        if (this.contact1 == null && this.contact2 == null) {
                            this.util.ErrorDialog("เกิดข้อผิดพลาดในการดึงข้อมูล Contact");
                        }
                        else {
                            this.mainChange(1);
                            this.clearActionActive();
                            event.target.classList.add("active");
                            $("#mergeModal").modal('show');
                        }
                        this.util.ShowWaiting(false);
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    IncomingContactComponent.prototype.beforeConfirmMerge = function () {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                this.util.ShowWaiting(true);
                req = this.chkMain == 1 ? this.contact1 : this.contact2;
                req.firstname = this.chkName == 1 ? this.contact1.firstname : this.contact2.firstname;
                req.lastname = this.chkLastname == 1 ? this.contact1.lastname : this.contact2.lastname;
                req.birthdate = this.chkDob == 1 ? this.contact1.birthdate : this.contact2.birthdate;
                req.dpa_idcard = this.chkIdNo == 1 ? this.contact1.dpa_idcard : this.contact2.dpa_idcard;
                req.emailaddress1 = this.chkEmail == 1 ? this.contact1.emailaddress1 : this.contact2.emailaddress1;
                req.telephone1 = this.chkTel == 1 ? this.contact1.telephone1 : this.contact2.telephone1;
                req.dpa_modifiedby = this.cookieData.userId;
                this.confirmMergeList = req;
                $("#mergeConfirmModal").modal('show');
                $("#mergeModal").modal('hide');
                this.util.ShowWaiting(false);
                return [2 /*return*/];
            });
        });
    };
    IncomingContactComponent.prototype.confirmMerge = function () {
        return __awaiter(this, void 0, void 0, function () {
            var req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        req = this.chkMain == 1 ? this.contact1 : this.contact2;
                        req.firstname = this.chkName == 1 ? this.contact1.firstname : this.contact2.firstname;
                        req.lastname = this.chkLastname == 1 ? this.contact1.lastname : this.contact2.lastname;
                        req.birthdate = this.chkDob == 1 ? this.contact1.birthdate : this.contact2.birthdate;
                        req.dpa_idcard = this.chkIdNo == 1 ? this.contact1.dpa_idcard : this.contact2.dpa_idcard;
                        req.emailaddress1 = this.chkEmail == 1 ? this.contact1.emailaddress1 : this.contact2.emailaddress1;
                        req.telephone1 = this.chkTel == 1 ? this.contact1.telephone1 : this.contact2.telephone1;
                        req.dpa_modifiedby = this.cookieData.userId;
                        return [4 /*yield*/, this.apiService.put("crmservice", "contact-merge/" + this.contact1.contactid + "/" + this.contact2.contactid, req)];
                    case 1:
                        res = _a.sent();
                        if (!this.util.isSuccessResponse(res)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.search(true)];
                    case 2:
                        _a.sent();
                        $("#mergeConfirmModal").modal('hide');
                        this.util.SuccessDialog("Merge conatct สำเร็จ");
                        return [3 /*break*/, 4];
                    case 3:
                        this.util.ShowWaiting(false);
                        this.util.ErrorDialog("Merge conatct ไม่สำเร็จ");
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IncomingContactComponent.prototype.onCheckAllChange = function () {
        $(".row-checker").prop("checked", this.isCheckedAll);
    };
    IncomingContactComponent.prototype.getSelectedContact = function () {
        var thisTs = this;
        this.selectList = [];
        $('.row-checker:checkbox:checked').each(function () {
            var value = {
                contactId: $(this).val(),
                fullname: $(this).closest('tr').find('td.col-fullname')[0].innerHTML,
                tel: $(this).closest('tr').find('td.col-tel')[0].innerHTML,
                email: $(this).prop("name")
            };
            thisTs.selectList.push(value);
        });
    };
    IncomingContactComponent.prototype.search = function (getAll) {
        if (getAll === void 0) { getAll = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var filtered, para, firstname, lastname, phoneNo, name_1, i, req, phone, firstname, lastname, phoneNo, req;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        $('#tbContact').DataTable().clear().destroy();
                        filtered = [];
                        if (!getAll) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiService.get("crmservice", "contact")];
                    case 1:
                        filtered = _a.sent();
                        return [3 /*break*/, 6];
                    case 2:
                        para = "";
                        if (this.firstnameSearch.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "firstname=" + this.firstnameSearch;
                        }
                        if (this.lastnameSearch.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "lastname=" + this.lastnameSearch;
                        }
                        if (this.telephoneSearch.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "telephoneno=" + this.telephoneSearch;
                        }
                        if (this.idcardSearch.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "idcard=" + this.idcardSearch;
                        }
                        if (this.accountNoSearch.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "accountno=" + this.accountNoSearch;
                        }
                        if (!(para.length > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.apiService.get("crmservice", "contact", para)];
                    case 3:
                        filtered = _a.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.apiService.get("crmservice", "contact")];
                    case 5:
                        filtered = _a.sent();
                        _a.label = 6;
                    case 6:
                        if (!(filtered != null && filtered.length > 0)) return [3 /*break*/, 7];
                        this.contactList = filtered.filter(function (c) {
                            return c.statusreason == 1 || c.statusreason == "1";
                        });
                        return [3 /*break*/, 14];
                    case 7:
                        if (!this.isCrisis) return [3 /*break*/, 14];
                        return [4 /*yield*/, this.getDrosContact()];
                    case 8:
                        _a.sent();
                        return [4 /*yield*/, this.getDAContact()];
                    case 9:
                        _a.sent();
                        if (!(this.contactDros != null && this.contactDros.CRM06 != null)) return [3 /*break*/, 11];
                        firstname = "";
                        lastname = "";
                        phoneNo = "";
                        try {
                            name_1 = this.contactDros.CRM06.Name.split(" ");
                            if (name_1.length > 0) {
                                if (name_1.length == 1) {
                                    firstname = name_1[0];
                                }
                                else if (name_1.length == 2) {
                                    firstname = name_1[0];
                                    lastname = name_1[1];
                                }
                                else if (name_1.length > 2) {
                                    for (i = 0; i < name_1.length - 1; i++) {
                                        firstname += " " + name_1[i];
                                    }
                                    firstname = firstname.trim();
                                    lastname = name_1[name_1.length - 1];
                                }
                            }
                        }
                        catch (e) {
                            console.log(e);
                        }
                        if (this.telephoneNo != null && this.telephoneNo.trim().length > 0) {
                            phoneNo = this.telephoneNo;
                        }
                        else {
                            phoneNo = this.contactDros.CRM06.PhoneNo;
                        }
                        req = {
                            createdon: new Date().toISOString(),
                            modifiedon: new Date().toISOString(),
                            firstname: firstname,
                            lastname: lastname,
                            dpa_idcard: this.contactDros.CRM06.IDNo,
                            dpa_authorizedperson_idcard: this.contactDros.CRM06.IDNo,
                            dpa_authorizedperson_telephone: phoneNo,
                            telephone1: phoneNo,
                            emailaddress1: this.contactDros.CRM06.Email,
                            statusreason: 1,
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "contact", req).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    if (this.util.isSuccessResponse(res)) {
                                        if (res.contactid != null && res.contactid != "") {
                                            //new tab customer4tab (2)
                                            //this.router.navigate(["/customer/" + res.contactid])
                                            this.search();
                                        }
                                        else {
                                            this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DROS ไม่สำเร็จ");
                                        }
                                    }
                                    else {
                                        this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DROS ไม่สำเร็จ");
                                    }
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 10:
                        _a.sent();
                        return [3 /*break*/, 14];
                    case 11:
                        if (!(this.contactDa != null && this.contactDa.FirstName != null)) return [3 /*break*/, 13];
                        phone = this.contactDa.MobileNumber.split(",");
                        firstname = this.contactDa.FirstName;
                        lastname = this.contactDa.LastName;
                        phoneNo = "";
                        if (this.telephoneNo != null && this.telephoneNo.trim().length > 0) {
                            phoneNo = this.telephoneNo;
                        }
                        else {
                            if (phone.length > 0 && phone[0] != "N/A") {
                                phoneNo = phone[0];
                            }
                            else {
                                phoneNo = this.telephoneNo;
                            }
                        }
                        req = {
                            createdon: new Date().toISOString(),
                            modifiedon: new Date().toISOString(),
                            firstname: firstname,
                            lastname: lastname,
                            dpa_idcard: this.contactDa.IdentityNumber,
                            dpa_authorizedperson_idcard: this.contactDa.IdentityNumber,
                            dpa_authorizedperson_telephone: phoneNo,
                            telephone1: phoneNo,
                            emailaddress1: this.contactDa.EmailAddress,
                            statusreason: 1,
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "contact", req).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    if (this.util.isSuccessResponse(res)) {
                                        if (res.contactid != null && res.contactid != "") {
                                            //new tab customer4tab (2)
                                            this.router.navigate(["/customer/" + res.contactid]);
                                        }
                                        else {
                                            this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DA ไม่สำเร็จ");
                                        }
                                    }
                                    else {
                                        this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DA ไม่สำเร็จ");
                                    }
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 12:
                        _a.sent();
                        return [3 /*break*/, 14];
                    case 13:
                        this.util.WarningDialog("ไม่พบข้อมูล");
                        _a.label = 14;
                    case 14:
                        this.util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    IncomingContactComponent.prototype.resetSearchCirteria = function () {
        this.firstnameSearch = "";
        this.lastnameSearch = "";
        this.telephoneSearch = "";
        this.idcardSearch = "";
        this.accountNoSearch = "";
    };
    IncomingContactComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.tbCon.changes.subscribe(function (t) {
            _this.initTableCon();
        });
    };
    IncomingContactComponent.prototype.ngForRendred = function () {
        console.log('NgFor is Rendered');
        if (this.dtCon == null) {
            this.initTableCon();
        }
    };
    IncomingContactComponent.prototype.initTableCon = function () {
        var thisTs = this;
        $('#tbContact td:not(.checkbox-col)').click(function (event) {
            return __awaiter(this, void 0, void 0, function () {
                var url;
                return __generator(this, function (_a) {
                    url = thisTs.util.baseUrl() + "/customer/" + $(this).parent('tr').find("input[type='checkbox']")[0].value;
                    window.open(url, '_blank');
                    return [2 /*return*/];
                });
            });
        });
        this.dtCon = $("#tbContact").DataTable({
            retrieve: true,
            'searching': false,
            "order": [],
            columnDefs: [{ orderable: false, targets: [0] }]
        });
    };
    IncomingContactComponent.prototype.mainChange = function (num) {
        this.chkMain = num;
        this.chkName = num;
        this.chkLastname = num;
        this.chkDob = num;
        this.chkIdNo = num;
        this.chkEmail = num;
        this.chkTel = num;
    };
    IncomingContactComponent.prototype.getDrosContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        para = "CRM06=true";
                        if (this.idcardSearch != null && this.idcardSearch.toString().trim().length > 0) {
                            para += "&dpa_id=" + this.idcardSearch;
                        }
                        if (this.telephoneSearch != null && this.telephoneSearch.toString().trim().length > 0) {
                            para += "&telephoneno=" + this.telephoneSearch;
                        }
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("crmservice", "contactDros", para)]; //ค้น DROS
                    case 1:
                        _a.contactDros = _b.sent(); //ค้น DROS
                        return [2 /*return*/];
                }
            });
        });
    };
    IncomingContactComponent.prototype.getDAContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        para = "";
                        if (this.idcardSearch != null && this.idcardSearch.toString().trim().length > 0) {
                            para += "IdNo=" + this.idcardSearch;
                        }
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("crmservice", "getDA", para)]; //ค้น DA
                    case 1:
                        _a.contactDa = _b.sent(); //ค้น DA
                        return [2 /*return*/];
                }
            });
        });
    };
    return IncomingContactComponent;
}());
export { IncomingContactComponent };



// WEBPACK FOOTER //
// ./src/app/incoming-contact/incoming-contact.component.ts.pre-build-optimizer.js